import * as yup from "yup";

import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContentText, Grid, Typography } from "@mui/material";
import TextInput from "@/components/hookForms/textField";
import { useForm } from "react-hook-form";
import serviceClienteInstalacao from "@/services/serviceClienteInstalacao";
import { toast } from "react-toastify";
import messages from "@/utils/messages";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";

export interface IProps {
    open: boolean;
    onClose: any;
    onSuccess: any;
    travaFaturaState: any;
}

export default function DialogTravaFatura(props: IProps) {
    const [isLoading, setLoading] = useState(false);

    const validationSchema = yup.object().shape({
        observacao: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            observacao: "",
        },
    });

    const onEditTravaFatura = (data: any) => {
        if (!data.observacao) {
            delete data.observacao;
        }

        setLoading(true);
        serviceClienteInstalacao
            .update({
                ...props.travaFaturaState,
                observacao: data.observacao,
            })
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    props.onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setLoading(false);
                reset();
                props.onClose();
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            open={props.open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    reset();
                    props.onClose();
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Trava de Fatura</DialogTitle>
            {props.travaFaturaState.travaFatura === "Sim" ? (
                <form onSubmit={handleSubmit(onEditTravaFatura)}>
                    <DialogContent dividers>
                        <Typography variant="body1">
                            Insira uma Observação para alterar o cadastro de trava de fatura do cliente!
                        </Typography>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <TextInput
                                    id="observacao"
                                    name="observacao"
                                    label="Observação"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            id="não"
                            onClick={() => {
                                reset();
                                props.onClose();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Não
                        </Button>
                        <LoadingButton
                            id="sim"
                            type="submit"
                            disabled={isLoading}
                            loading={isLoading}
                            color="primary"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Sim
                        </LoadingButton>
                    </DialogActions>
                </form>
            ) : (
                <>
                    <DialogContent style={{ padding: "30px 20px" }} dividers>
                        <DialogContentText id="alert-dialog-description">
                            <Typography variant="body1">{messages.confirmTableEditTravaFatura}</Typography>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            id="não"
                            onClick={props.onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Não
                        </Button>
                        <LoadingButton
                            id="sim"
                            loading={isLoading}
                            onClick={() => onEditTravaFatura({ ...props.travaFaturaState, observacao: null })}
                            color="primary"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Sim
                        </LoadingButton>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
